import { SxProps, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

export const chipSx =
  (color: string, small?: boolean): SxProps<Theme> =>
  () => ({
    backgroundColor: alpha(color, 0.2),
    border: '1px solid #FFFFFF1A',

    '& .MuiChip-label': {
      fontSize: small ? 12 : 'clamp(0.7rem, 0.25vw + 0.65rem, 0.9rem)',
      lineHeight: 1.1,
    },

    '& .MuiChip-icon': {
      color,
      fontSize: small ? 14 : 'clamp(14px, 0.5vw + 12px, 18px)',
    },
  });
